import React, { useState, useEffect, useRef } from "react"
import SessionConfig from "../../config/session_config"
import { useDispatch, useSelector } from "react-redux"
import {
  Col,
  Container,
  Row,
  Button,
  ButtonGroup,
  Modal,
  ModalHeader,
  ModalBody,
  Card,
  CardBody,
  Label,
} from "reactstrap"
import { Link } from "react-router-dom"
import Select from "react-select"
import LinearIndeterminate from "../../components/Common/LinearIndeterminate"
import NotificationsEmailForm from "./NotificationsEmailForm"
import NotificationEditForm from "./NotificationsEditForm"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import showToast from "../../components/Common/viewNotification"
import DataTable from "react-data-table-component"
import {
  getNotificationsEmail,
  getStatusOrder,
  deleteNotificationEmail,
} from "../../store/actions"
import { useTranslation } from "react-i18next"
import "./Notifications.scss"

const notificationsEmail = () => {
  const dispatch = useDispatch()
  const ref = useRef()
  const [clearSelectedRows, setclearSelectedRows] = useState(false)
  const { t } = useTranslation()
  const [columns, setColumns] = useState([])
  const [selectRows, setSelectRows] = useState([])
  const [currentNotificationEmail, setCurrentNotificationEmail] = useState(null)
  const [modal, setModal] = useState(false)
  const [modalEdit, setModalEdit] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [modalMessage, setModalMessage] = useState(false)
  const [statusOrder, setStatusOrder] = useState({
    value: "",
    label: t("global:Search"),
    error: "",
  })
  const [data, setData] = useState({
    page: 0,
    size: 10,
  })
  const {
    notificationEmailList = [],
    loading,
    statusOrders = [],
    responseDelete,
    error,
  } = useSelector(state => ({
    notificationEmailList: state.NotificationsEmail.notificationEmailList,
    loading: state.NotificationsEmail.loading,
    statusOrders: state.NotificationsEmail.statusOrder,
    responseDelete: state.NotificationsEmail.responseDelete,
    error: state.NotificationsEmail.error,
  }))
    // header title
    document.title = t("notificationsEmail:titleNotifications") + " | " + t("global:title")
  useEffect(() => {
    document.getElementById("body").className = "fondo2"
    loadPage()
  }, [])

  const loadPage = async () => {
    initColumns()
    await dispatch(getStatusOrder())
  }

  useEffect(() => {
    loadData()
  }, [data.size, data.page])
  const updateState = (value, id) => {
    setData({
      ...data,
      [id]: value,
    })
  }

  useEffect(() => {
    if (responseDelete !== null) {
      if (responseDelete.length > 0) {
        showToast(
          t("global:msgSuccessDeleteList"),
          "success",
          t("global:titleModalDelete")
        )
        loadData()
      }
    }
  }, [responseDelete])

  const handlePageChange = async page => {
    data.page = parseInt(page) - 1
    if (data.page < 0) {
      data.page = 0
    }
    await updateState(data.page, "page")
  }

  const handlePerRowsChange = async (perPage, page) => {
    data.size = perPage
    data.page = parseInt(page) - 1
    if (data.page < 0) {
      data.page = 0
    }
    await updateState(data.size, "size")
    await updateState(data.page, "page")
  }

  const handleRowSelected = React.useCallback(state => {
    setSelectRows(state.selectedRows)
  }, [])

  const loadData = async (obj = { value: "" }) => {
    const filter = {
      areaId: obj.value,
      length: data.size,
      page: data.page,
    }
    await dispatch(getNotificationsEmail(filter))
  }
  const toggle = () => {
    setModal(!modal)
  }
  const toggleEdit = () => {
    setModalEdit(!modalEdit)
  }

  const addNotificationEmail = () => {
    setIsEdit(false)
    setCurrentNotificationEmail(null)
    toggle()
  }

  const editNotificationEmail = row => {
    setIsEdit(true)
    setCurrentNotificationEmail(row)
    toggleEdit()
  }
  const emailNotificationDisable = async () => {
    if (selectRows.length > 0) {
      setclearSelectedRows(true)
      await dispatch(deleteNotificationEmail(selectRows))
      setclearSelectedRows(false)
      setSelectRows([])
      toggleMessage()
    } else showToast(t("error:msgSelectItems"), "error", t("error:title"))
  }
  const toggleMessage = () => {
    setModalMessage(!modalMessage)
  }
  const initColumns = () => {
    let col = [
      {
        name: t("notificationsEmail:lblEmail"),
        sortable: false,
        wrap: true,
        grow: 2,
        cell: row => (
          <span>
            <div>
              {" "}
              <b>{row.email}</b>
            </div>
          </span>
        ),
      },
      {
        name: t("notificationsEmail:lblStatusOrder"),
        sortable: false,
        wrap: true,
        grow: 1,
        cell: row => <div>{row.area.name}</div>,
        width: "20%",
      },
      {
        name: t("notificationsEmail:titleStatus"),
        sortable: false,
        wrap: true,
        grow: 1,
        cell: row => (
          <>
            <span
              to="#"
              className={
                row.status === 1
                  ? "badge badge-soft-primary font-size-11 m-1"
                  : "badge badge-soft-danger font-size-11 m-1"
              }
            >
              {row.status === 1 ? "HABILITADO" : "DESHABILITADO"}
            </span>
          </>
        ),
      },
      {
        name: "Accion",
        cell: row => (
          <div className="d-flex gap-3">
            <Link className="text-success" to="#">
              <i
                className="fa fa-edit font-size-18"
                id="edittooltip"
                onClick={() => editNotificationEmail(row)}
              ></i>
            </Link>
          </div>
        ),
      },
    ]
    setColumns(col)
  }
  const lsStatusOrder = () => {
    if (statusOrders.length > 0) {
      return statusOrders?.map(item => {
        return { value: item.id, label: item.name }
      })
    } else {
      return []
    }
  }
  const changeStatusOrder = value => {
    if (value === null) {
      setStatusOrder({ value: "", label: "" })
      reloadData()
    } else {
      setStatusOrder({ value: value.value, label: value.label })
    }
  }

  const reloadData = async () => {
    setStatusOrder({ value: "", label: t("global:Search") })
    const filter = {
      areaId: null,
      length: data.size,
      page: data.page,
    }
    await dispatch(getNotificationsEmail(filter))
  }

  return (
    <>
      <React.Fragment>
        <SessionConfig ref={ref} />
        <div className="page-content">
          <Container fluid>
            <Breadcrumbs
              title={t("global:title")}
              breadcrumbItem={t("notificationsEmail:titleNotifications")}
            />
            <Row>
              <Col lg="12">
                <Card>
                  <CardBody>
                    <Row className=" d-flex align-items-end filter-style">
                      <Col md={3}>
                        <Label htmlFor="name">
                          {t("notificationsEmail:titleFilter")}
                        </Label>
                        <div>
                          <Select
                            name="status"
                            classNamePrefix="select"
                            options={lsStatusOrder()}
                            value={statusOrder}
                            isClearable
                            isSearchable
                            onChange={value => {
                              changeStatusOrder(value)
                              loadData(value)
                            }}
                          />
                          <span className="small text-danger">
                            {statusOrder.error}
                          </span>
                        </div>
                      </Col>
                      <Col>
                        <div className="text-sm-end">
                          <ButtonGroup>
                            <Button
                              color="danger"
                              disabled={loading || !selectRows.length}
                              onClick={toggleMessage}
                            >
                              <i className=" fas fa-times-circle me-1 " />
                              {t("global:setdisabled")}
                            </Button>
                            <Button
                              color="primary"
                              disabled={loading}
                              className="font-16 btn-block btn btn-primary "
                              onClick={addNotificationEmail}
                            >
                              <i className="fas fa-plus-circle me-1" />
                              {t("global:add")}
                            </Button>
                          </ButtonGroup>
                        </div>
                      </Col>
                    </Row>
                    <Row className="mt-4">
                      <Col>
                        <label className="text-primary text-uppercase font-size-16">
                          <i className="fa fa-list font-size-18  me-1 " />
                          {t("notificationsEmail:titleTable")}
                        </label>
                      </Col>
                    </Row>
                    <DataTable
                      columns={columns}
                      data={notificationEmailList.notificationEmailList}
                      onSelectedRowsChange={handleRowSelected}
                      fixedHeaderScrollHeight="500px"
                      dense
                      selectableRows
                      pointerOnHover={true}
                      highlightOnHover
                      pagination
                      paginationServer
                      paginationTotalRows={
                        notificationEmailList ? notificationEmailList.size : 0
                      }
                      paginationDefaultPage={1}
                      onChangePage={handlePageChange}
                      paginationComponentOptions={{
                        rowsPerPageText: t("tableOptions:rowsPerPageText"),
                        rangeSeparatorText: t(
                          "tableOptions:rangeSeparatorText"
                        ),
                        selectAllRowsItem: true,
                        selectAllRowsItemText: t(
                          "tableOptions:selectAllRowsItemText"
                        ),
                      }}
                      clearSelectedRows={clearSelectedRows}
                      noDataComponent={t("tableOptions:noDataComponent")}
                      progressPending={loading}
                      progressComponent={<LinearIndeterminate />}
                      persistTableHead
                      onChangeRowsPerPage={handlePerRowsChange}
                      contextMessage={{
                        singular: t("tableOptions:singular"),
                        plural: t("tableOptions:plural"),
                        message: "",
                      }}
                    />
                    <Modal isOpen={modal} toggle={toggle} backdrop={"static"}>
                      <ModalHeader
                        toggle={toggle}
                        tag="h4"
                        close={<span></span>}
                      >
                        {t("notificationsEmail:titleAddRegister")}
                      </ModalHeader>
                      <ModalBody>
                        <NotificationsEmailForm
                          onClosing={toggle}
                          isEdit={isEdit}
                          currentNotificationEmail={currentNotificationEmail}
                          onLoad={loadData}
                          statusOrders={statusOrders}
                        />
                      </ModalBody>
                    </Modal>
                    <Modal
                      isOpen={modalEdit}
                      toggle={toggleEdit}
                      backdrop={"static"}
                    >
                      <ModalHeader
                        toggle={toggleEdit}
                        tag="h4"
                        close={<span></span>}
                      >
                        {t("notificationsEmail:titleAddRegister")}
                      </ModalHeader>
                      <ModalBody>
                        <NotificationEditForm
                          onClosing={toggleEdit}
                          isEdit={isEdit}
                          currentNotificationEmail={currentNotificationEmail}
                          onLoad={loadData}
                          statusOrders={statusOrders}
                        />
                      </ModalBody>
                    </Modal>
                    <Modal
                      isOpen={modalMessage}
                      toggle={toggleMessage}
                      backdrop={"static"}
                    >
                      <ModalHeader
                        toggle={toggleMessage}
                        tag="h4"
                        close={<span></span>}
                      >
                        {t("global:titleModalDelete")}
                      </ModalHeader>
                      <ModalBody>
                        <Col>
                          <div>{t("global:messageDelete")}</div>
                        </Col>
                        <Col>
                          <div className="text-end">
                            <ButtonGroup>
                              <Button
                                type="submit"
                                className="btn btn-info save-user"
                                onClick={() => {
                                  emailNotificationDisable()
                                }}
                              >
                                <i className=" fas fa-save me-1 "> {"  "}</i>
                                {t("supplier:btnModalSave")}
                              </Button>
                              <button
                                type="button"
                                className="btn btn-danger "
                                onClick={() => {
                                  toggleMessage(false)
                                }}
                              >
                                {" "}
                                {t("global:close")}
                              </button>
                            </ButtonGroup>
                          </div>
                        </Col>
                      </ModalBody>
                    </Modal>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    </>
  )
}
export default notificationsEmail
